import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import API, { formatApiErrorDetail } from "../lib/api";
import AdminLayout from "./AdminLayout";
import { useAppT } from "../components/home/i18n";
import { CheckCircle2 } from "lucide-react";

export default function AdminJobs() {
  const { a } = useAppT();
  const [jobs, setJobs] = useState([]);
  const [filter, setFilter] = useState("submitted");
  const [reasonFor, setReasonFor] = useState(null);
  const [reason, setReason] = useState("");
  const load = async () => { const { data } = await API.get("/admin/jobs"); setJobs(data.jobs); };
  useEffect(() => { load(); }, []);

  const act = async (id, action, body = {}) => {
    try { await API.post(`/admin/jobs/${id}/${action}`, body); toast.success(a.adminJobs.done); setReasonFor(null); setReason(""); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const shown = jobs.filter((j) => filter === "all" ? true : j.status === filter);

  return (
    <AdminLayout>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h1 className="font-serif text-3xl text-[#173A2C]">{a.adminJobs.title}</h1>
        <div className="flex gap-1 rounded-full border border-[#E8E4DB] bg-white p-1">
          {["submitted", "approved", "all"].map((f) => {
            const n = f === "all" ? jobs.length : jobs.filter((j) => j.status === f).length;
            return <button key={f} data-testid={`jobfilter-${f}`} onClick={() => setFilter(f)} className={`rounded-full px-3 py-1 text-sm ${filter === f ? "bg-[#1F4A38] text-white" : "text-[#5C5855]"}`}>{a.adminJobs.filters[f]} {n}</button>;
          })}
        </div>
      </div>
      <div className="mt-6 space-y-3" data-testid="admin-jobs-list">
        {shown.length === 0 && <div className="text-sm text-[#5C5855]">{a.common.nothingHere}</div>}
        {shown.map((j) => (
          <div key={j.id} className="rounded-md border border-[#E8E4DB] bg-white p-4">
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <div className="font-serif text-lg text-[#173A2C]">{j.title} <span className="ml-2 text-xs font-semibold text-[#5C5855]">{a.adminJobs.filters[j.status] || j.status}</span></div>
                <div className="text-sm text-[#5C5855]">{j.employer_org} · {j.profession} · {j.location}</div>
                <p className="mt-1 text-sm text-[#2C2A29]">{j.description}</p>
                <div className="mt-1 text-xs text-[#5C5855]">{a.adminJobs.mandatoryPrefix} {(j.criteria_mandatory || []).map((c) => `${c.type}:${c.value}`).join(", ") || a.adminJobs.noneWord}</div>
                {j.review_reason && <div className="text-xs text-[#8B3A3A]">{a.adminJobs.reasonPrefix} {j.review_reason}</div>}
              </div>
              <div className="flex flex-col items-end gap-2">
                <button data-testid={`approve-job-${j.id}`} onClick={() => act(j.id, "approve")} className="inline-flex items-center gap-1 rounded-full bg-[#2E6B4B] px-4 py-1.5 text-xs font-semibold text-white"><CheckCircle2 className="h-3.5 w-3.5" /> {a.adminJobs.approve}</button>
                <button data-testid={`reject-job-${j.id}`} onClick={() => setReasonFor(j.id)} className="rounded-full border border-[#8B3A3A] px-4 py-1.5 text-xs font-semibold text-[#8B3A3A]">{a.adminJobs.reject}</button>
              </div>
            </div>
            {reasonFor === j.id && (
              <div className="mt-3 rounded-sm border border-[#E8E4DB] p-3">
                <textarea data-testid="job-reason-input" rows="2" value={reason} onChange={(e) => setReason(e.target.value)} placeholder={a.adminJobs.reasonToReject} className="w-full rounded-sm border border-[#E8E4DB] px-3 py-2 text-sm outline-none focus:border-[#1F4A38]" />
                <div className="mt-2 flex gap-2">
                  <button data-testid="job-reject-submit" onClick={() => reason.trim() ? act(j.id, "reject", { reason }) : toast.error(a.adminJobs.reasonRequired)} className="rounded-sm bg-[#8B3A3A] px-3 py-1.5 text-xs font-semibold text-white">{a.adminJobs.reject}</button>
                  <button onClick={() => { setReasonFor(null); setReason(""); }} className="rounded-sm border border-[#E8E4DB] px-3 py-1.5 text-xs">{a.common.cancel}</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
